import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Login } from 'src/models/request/Login';
import { RequestBody } from 'src/models/request/RequestBody';
import { ResponseBody } from 'src/models/response/ResponseBody';
import { WebserviceService } from 'src/services/webservice';
import { LoginResponse } from 'src/models/response/LoginResponse';
import { SnackerService } from 'src/app/shared/snacker.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { Mode } from 'src/models/others/Mode';
import { ModeService } from 'src/services/mode.service';
import { FunctionEnum } from 'src/models/others/FunctionEnum';
import { DatatransferService } from 'src/services/datatransfer.service';
import { TokenStorageService } from 'src/services/token-storage.service';
import { StorageEnum } from 'src/models/others/StorageEnum';
// import { DesktopNotificationService } from 'src/services/desktop-notification.service';
import { ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TemplateRef, ViewChild } from '@angular/core';
import { CommonPopupService } from 'src/app/shared/common-popup/common-popup.service';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { MessageEnum } from 'src/models/others/MessageEnum';
import { CommonModule } from '@angular/common';
import { Menu } from 'src/models/others/Menu';
import { MenuHeader } from 'src/models/others/MenuHeader';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NgxSpinnerModule,
    MatSnackBarModule,
    MatDialogModule
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  resetPassword: FormGroup;
  submitted: boolean = false;
  isPhoneNumber: boolean;
  show: boolean = false;
  isLoggedIn: boolean = false;
  type: string = "password";
  passwordState: string = "fa-solid fa-eye";
  emailRegex = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  patternPhoneNumber = '[0-9]{10}$';

  loginDto: Login = new Login;
  requestBase: RequestBody = new RequestBody;
  loginResponse: LoginResponse = new LoginResponse;
  responseBase: ResponseBody = new ResponseBody;
  closeResult: string;
  currentYear: number = new Date().getFullYear();

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private webservice: WebserviceService,
    private snacker: SnackerService,
    private commonPopup: CommonPopupService,
    private spinner: NgxSpinnerService,
    private dataTransfer: DatatransferService,
    private token: TokenStorageService,
    // private desktopNotification: DesktopNotificationService,
    private modeSwitch: ModeService) { }

  @ViewChild('resetPassAlertContent', { static: true }) resetPassAlertTpl: TemplateRef<any>;

  openResetPassword() {
    this.resetPassword.reset();
    const modalProxy: any = { close: (r?: any) => { }, dismiss: (r?: any) => { } };
    const ref = this.commonPopup.openSmall({ title: 'Reset Password', template: this.resetPassAlertTpl, context: { $implicit: modalProxy } });
    modalProxy.close = (r?: any) => ref.close(r);
    modalProxy.dismiss = (r?: any) => ref.close(r);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    }
    else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      userName: [null, Validators.required],
      password: [null, Validators.required]
    });
    this.resetPassword = this.formBuilder.group({
      emailId: [null, Validators.required]
    });
  }
  get f() {
    return this.loginForm.controls;
  }
  onKeypressEvent(event) {
    this.isPhoneNumber = false;
    let str: any;
    if (event.target.value.charAt(0) != '') {
      str = event.target.value.charAt(0)
      if (!isNaN(str)) {
        this.isPhoneNumber = true;
      }
      else {
        this.isPhoneNumber = false;
      }
    }
    if (this.isPhoneNumber) {
      this.submitted = false;
      this.loginForm.get('userName')?.setValidators(Validators.compose([Validators.required, Validators.pattern(this.patternPhoneNumber)]))
    } else {
      this.submitted = false;
      this.loginForm.get('userName')?.setValidators(Validators.compose([Validators.required, Validators.pattern(this.emailRegex)]));
    }
  }
  showPassword() {
    this.show = !this.show;
    this.passwordState = this.show ? "fa-solid fa-eye-slash" : "fa-solid fa-eye";
  }
  onSubmit() {
    this.submitted = true;
    if (this.f.userName.value == null || this.f.userName.value == '' || this.f.password.value == null || this.f.password.value == '') {
      this.snacker.error("enter user details")
      return null;
    }
    this.spinner.show();
    this.loginDto.emailOrMobileNo = this.f.userName.value.toLowerCase();
    this.loginDto.password = this.f.password.value;

    this.requestBase.function = FunctionEnum.Login;
    this.requestBase.payload = this.loginDto;
    this.webservice.loginRequest(this.requestBase).subscribe((response: any) => {

      if (response != null) {

        this.spinner.hide();

        this.responseBase = response;
        this.snacker.success(
          "Login successful"
        );

        if (this.responseBase.result == MessageEnum.SUCCESS) {
          // this.desktopNotification.show('Login successful', {
          //   body: 'Welcome to Aether HRMS.'
          // });

          sessionStorage.setItem(
            StorageEnum.getUserName,
            this.loginDto.emailOrMobileNo
          );

          this.loginResponse = this.responseBase.payload;

          sessionStorage.setItem(
            StorageEnum.getEmployeeId,
            this.loginResponse.personId
          );

          this.token.saveToken(
            this.loginResponse.authToken.accessToken,
            this.loginResponse.authToken.refreshToken
          );

          /* ================= MENUS ================= */

          const menuHeaders: MenuHeader[] =
            (this.loginResponse.menus || []).map((header: any) => ({

              menuHeaderId: header.menuHeaderId,

              menuHeaderName: header.menuHeaderName,

              subMenuList: (header.subMenuList || []).map((sub: any) => ({

                menuId: sub.menuId,

                menuName: sub.menuName,

                parentMenuId: sub.parentMenuId

              } as Menu))

            } as MenuHeader));

          this.dataTransfer.setMenuList(menuHeaders);

          sessionStorage.setItem(
            StorageEnum.getMenuHeaderList,
            JSON.stringify(menuHeaders)
          );

          /* ================= FLAT MENU ================= */

          const flatMenuList: Menu[] = [];

          menuHeaders.forEach((header) => {

            if (header.subMenuList) {

              header.subMenuList.forEach((submenu) => {

                flatMenuList.push(submenu);

              });
            }
          });

          /* ================= SESSION ================= */

          const menuIdList: number[] =
            flatMenuList.map((m) => m.menuId);

          const menuNameList: string[] =
            flatMenuList.map((m) => m.menuName);

          sessionStorage.setItem(
            StorageEnum.getMenuNameList,
            JSON.stringify(menuNameList)
          );

          sessionStorage.setItem(
            StorageEnum.getMenuIdList,
            JSON.stringify(menuIdList)
          );

          this.dataTransfer.setNtfFlag(true);

          sessionStorage.setItem(
            StorageEnum.getPersonName,
            this.responseBase.payload.name
          );

          /* ================= LOGIN NAVIGATION ================= */

          if (
            this.responseBase.payload.passwordreset == "No"
            && flatMenuList.length > 0
          ) {

            const firstMenu = flatMenuList[0];

            this.dataTransfer.setMenuName(firstMenu.menuName);

            this.dataTransfer.setMenuId(firstMenu.menuId);
            switch (firstMenu.menuId) {

              case 1: {

                this.modeSwitch.setMode(Mode.taskMode);

                this.router.navigate(
                  ['homepage/my-task-list']
                );

                break;
              }

              case 2: {

                this.modeSwitch.setMode(Mode.assignMode);

                this.router.navigate(
                  ['homepage/assign-task-list']
                );

                break;
              }

              case 3: {

                this.modeSwitch.setMode(Mode.reviewMode);

                this.router.navigate(
                  ['homepage/review-task-list']
                );

                break;
              }

              case 4: {

                this.router.navigate(
                  ['homepage/manage-person']
                );

                break;
              }

              case 5: {

                this.router.navigate(
                  ['homepage/task-report']
                );

                break;
              }

              case 6: {

                this.router.navigate(
                  ['homepage/leave-report']
                );

                break;
              }

              case 7: {

                this.router.navigate(
                  ['homepage/manage-team']
                );

                break;
              }

              case 8: {

                this.router.navigate(
                  ['homepage/manage-project']
                );

                break;
              }

              case 13: {

                this.router.navigate(
                  ['homepage/allocation-report']
                );

                break;
              }

              default: {

                this.router.navigate(
                  ['homepage']
                );

                break;
              }
            }

          } else if (
            this.responseBase.payload.passwordreset == "Yes"
          ) {

            this.router.navigateByUrl(
              'reset-password',
              {
                queryParams: {
                  data: null,
                  key: this.f.password.value
                }
              } as any
            );
          }

          this.webservice.addHeader();

        } else {

          if (
            this.f.userName.value == null
            && this.f.password.value == null
          ) {

            this.spinner.hide();

            this.snacker.error(
              this.responseBase.resultmessage.substring(
                0,
                this.responseBase.resultmessage.indexOf(',')
              )
            );

          } else {

            this.spinner.hide();

            this.snacker.error(
              this.responseBase.resultmessage
            );
          }
        }
      }
    }, () => {
      this.spinner.hide();
      this.snacker.error("Server error");
    }
    );
  }
  get getEmail() {
    return this.resetPassword.controls;
  }
  onResetPasswordSubmit() {
    if (this.getEmail.emailId.value == null) {
      this.snacker.error('Please enter valid Email-id.');
      return;
    }
    this.spinner.show();
    this.requestBase.function = FunctionEnum.ResetPass;
    this.requestBase.payload = this.getEmail.emailId.value.toLowerCase();
    this.webservice.resetPasswordRequest(this.requestBase).subscribe((response: any) => {
      this.spinner.hide();
      if (response != null) {
        if (response.result == "success") {
          this.snacker.success('New password sent to the register email-id.');
        } else {
          this.snacker.error('Email-id not found.');
        }
      }
    }, () => {
      this.spinner.hide();
      this.snacker.error("Server error");
    }
    );

  }

}
